// Header component for Studio1 Alpha
// Displays the Studio1 logo, breadcrumbs, and user profile

import React from "react";
import { useNavigate } from "react-router-dom";
import { UserProfile } from "./UserProfile";
import { Breadcrumb } from "../ui/breadcrumb";
import { RouteLoader } from "./RouteLoader";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { useNavigation } from "@/contexts/NavigationContext";
import { Notifications } from "@/components/notifications/Notifications";
import { BillingAccountSwitcher } from "./BillingAccountSwitcher";
import { BuyMoreCreditsButton } from "./BuyMoreCreditsButton";
import "./Header.css";

interface HeaderProps {
  className?: string;
}

export const Header: React.FC<HeaderProps> = ({ className = "" }) => {
  const navigate = useNavigate();
  const breadcrumbs = useBreadcrumbs();
  const { isLoading, loadingMessage } = useNavigation();

  return (
    <header className={`studio1-header ${className}`}>
      <div className="header-gradient-line" />

      <div className="header-content">
        {/* Logo */}
        <button
          onClick={() => navigate("/inspire")}
          className="logo-button"
          aria-label="Studio1 Home"
        >
          <img
            src="/logo.png"
            alt="Studio1 Logo"
            className="logo-image"
            style={{ height: "40px" }}
          />
        </button>

        {/* Breadcrumbs */}
        <div className="header-breadcrumbs">
          {isLoading ? (
            <RouteLoader variant="minimal" message={loadingMessage} />
          ) : (
            <Breadcrumb items={breadcrumbs} />
          )}
        </div>

        {/* User Profile */}
        <div className="header-actions">
          <BuyMoreCreditsButton />
          <BillingAccountSwitcher />
          <Notifications />
          <UserProfile className="" />
        </div>
      </div>
    </header>
  );
};
